import React from 'react';
// My Components
import './CustomFooter.scss';

export default function CustomFooter() {
  /* eslint-disable-next-line no-console */

  function determineDate() {
    const projectStartedYear = 2021;
    const thisYear = new Date().getFullYear();

    return `${projectStartedYear} ${(thisYear - projectStartedYear > 0 ? ` - ${thisYear}` : '')}`;
  }

  return (
    <div className="CustomFooter">
      <div className="copyright-container">
        <p className="lead">
          &copy;
          {determineDate()}
          {' '}
          Century Ballroom, All Rights Reserved.
        </p>
      </div>
    </div>
  );
}
